import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions from '~/Actions';
import { Dialog } from '@material-ui/core';
import { EAA_Btn } from '~/components/EditAndAddItem';
import { leftColor, rightColor } from '~/components/EditAndAddItem/common';

const Xlsx = () => (
  <svg style={{ marginTop: 59, marginBottom: 8 }} width="117" height="156" viewBox="0 0 117 156" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M68.25 41.4375V0H7.3125C3.26016 0 0 3.26016 0 7.3125V148.688C0 152.74 3.26016 156 7.3125 156H109.688C113.74 156 117 152.74 117 148.688V48.75H75.5625C71.5406 48.75 68.25 45.4594 68.25 41.4375ZM86.5617 73.8867L68.25 102.375L86.5617 130.863C88.1156 133.301 86.3789 136.5 83.4844 136.5H72.8508C71.5102 136.5 70.2609 135.769 69.6211 134.58C63.6492 123.551 58.5 113.648 58.5 113.648C56.55 118.158 55.4531 119.742 47.3484 134.611C46.7086 135.799 45.4898 136.53 44.1492 136.53H33.5156C30.6211 136.53 28.8844 133.331 30.4383 130.894L48.8109 102.405L30.4383 73.9172C28.8539 71.4797 30.6211 68.2805 33.5156 68.2805H44.1188C45.4594 68.2805 46.7086 69.0117 47.3484 70.2C55.3008 85.0687 53.4422 80.4375 58.5 91.0711C58.5 91.0711 60.3586 87.5062 69.6516 70.2C70.2914 69.0117 71.5406 68.2805 72.8812 68.2805H83.4844C86.3789 68.25 88.1156 71.4492 86.5617 73.8867ZM117 37.1414V39H78V0H79.8586C81.8086 0 83.6672 0.761719 85.0383 2.13281L114.867 31.9922C116.238 33.3633 117 35.2219 117 37.1414Z" fill="#511496" />
  </svg>
);

const Csv = () => (
  <svg style={{ marginTop: 59, marginBottom: 8 }} width="117" height="156" viewBox="0 0 117 156" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M68.25 41.4375V0H7.3125C3.26016 0 0 3.26016 0 7.3125V148.688C0 152.74 3.26016 156 7.3125 156H109.688C113.74 156 117 152.74 117 148.688V48.75H75.5625C71.5406 48.75 68.25 45.4594 68.25 41.4375ZM39 85.3125C39 86.6592 37.9092 87.75 36.5625 87.75H34.125C31.4316 87.75 29.25 89.9316 29.25 92.625V102.375C29.25 105.068 31.4316 107.25 34.125 107.25H36.5625C37.9092 107.25 39 108.341 39 109.688V114.562C39 115.909 37.9092 117 36.5625 117H34.125C26.0477 117 19.5 110.452 19.5 102.375V92.625C19.5 84.5477 26.0477 78 34.125 78H36.5625C37.9092 78 39 79.0908 39 80.4375V85.3125ZM52.4885 117H48.75C47.4033 117 46.3125 115.909 46.3125 114.562V109.688C46.3125 108.341 47.4033 107.25 48.75 107.25H52.4885C54.3014 107.25 55.6603 106.184 55.6603 105.233C55.6603 104.837 55.4318 104.423 55.0144 104.063L48.3448 98.344C45.7641 96.1441 44.2833 93.0181 44.2833 89.7701C44.2833 83.2802 50.0784 78.0031 57.2051 78.0031H60.9375C62.2842 78.0031 63.375 79.0938 63.375 80.4406V85.3156C63.375 86.6623 62.2842 87.7531 60.9375 87.7531H57.199C55.3861 87.7531 54.0272 88.8195 54.0272 89.7701C54.0272 90.1662 54.2557 90.5805 54.6731 90.9401L61.3427 96.6591C63.9234 98.8589 65.4042 101.985 65.4042 105.233C65.4073 111.72 59.6152 117 52.4885 117ZM78 80.4375V86.775C78 92.951 79.7367 99.0143 82.875 104.106C86.0133 99.0173 87.75 92.951 87.75 86.775V80.4375C87.75 79.0908 88.8408 78 90.1875 78H95.0625C96.4092 78 97.5 79.0908 97.5 80.4375V86.775C97.5 97.5853 93.5756 107.765 86.4459 115.443C85.5258 116.433 84.2309 117 82.875 117C81.5191 117 80.2242 116.433 79.3041 115.443C72.1744 107.765 68.25 97.5853 68.25 86.775V80.4375C68.25 79.0908 69.3408 78 70.6875 78H75.5625C76.9092 78 78 79.0908 78 80.4375ZM114.867 31.9922L85.0383 2.13281C83.6672 0.761719 81.8086 0 79.8586 0H78V39H117V37.1414C117 35.2219 116.238 33.3633 114.867 31.9922Z" fill="#5A397E" />
  </svg>
);

class AddUser extends Component {
   renderDialog=() => {
     const { isCsv = false, num = 0, onExport = () => {}, onClose = () => {} } = this.props;
     const _cancel = () => onClose();
     const _check = () => { onExport(); onClose(); };
     return (
       <div style={{ width: 515, height: 458, backgroundColor: 'white', borderRadius: 39, alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
         {!isCsv && <Xlsx />}
         {isCsv && <Csv />}
         <div style={{ fontSize: 25, marginBottom: 41 }}>
           確認要輸出資料？
         </div>
         <div style={{ fontSize: 24, marginBottom: 25 }}>
           {num > 0 && `總計 ${num} 筆 log , ${isCsv ? 'csv' : 'xlsx'} 格式`}
           {num === 0 && `${isCsv ? 'csv' : 'xlsx'} 格式`}
         </div>
         <div style={{ display: 'flex' }}>
           <EAA_Btn text='取消' style={{ height: 47, width: 155, marginRight: 16 }} backgroundColor={leftColor} onClick={_cancel} />
           <EAA_Btn text='確認' style={{ height: 47, width: 155 }} backgroundColor={rightColor} onClick={_check} />
         </div>
       </div>
     );
   }

   render () {
     return (
       <Dialog
         PaperComponent={this.renderDialog}
         open={true}
       />
     );
   }
}

const mapStateToProps = state => ({
  result: key => state.data[key],
});
const mapDispatchToProps = dispatch => ({
  clearKey: key => Actions.clearKey(dispatch, { key }),
});

const App_AddUser = connect(mapStateToProps, mapDispatchToProps)(AddUser);
const App = (props = { onExport: () => {}, onClose: () => {}, isCsv: false, num: 0 }) => <App_AddUser {...props} />;
export default App;
